/* eslint-disable array-callback-return */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-anonymous-default-export */
import { quickActionPinMobileIcon, quickActionShareMobileIcon, previewIcon, imsLoader, pushPinIcon, shareIcon, crossIcon, downloadIcon, quickActionIcon, supportingDocumentMobTabIcon, supportingDocumentWebIcon, quickActionDropDown, iconAuthoringBlue } from "../../assets"
import { Link } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import trackingService from "../../services/trackingService";
import GenerateArrayStrings from '../GenerateArrayStrings';
import SharePopup from "../SharePopup";
import './ActionBar.css';
import PinToReadingListPopUp from "../PopUp/PinToReadingListPopUp";
import DocumentPreview from "../Preview/DocumentPreview";
import AiNotebookDocumentPreview from "../Preview/AiNotebookDocumentPreview";
import { Modal } from "react-bootstrap";
import { Authoring, LocationOrigin } from "../../utils/utilityServices";
import axios from "axios";
import { Authentication } from "../../utils/authenticationUtilityServices";
import GenAIAuthoringIndex from "../GenAIAnswering2.0/GenAIAuthoringIndex";
import { v4 as uuidv4 } from 'uuid';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import AuthoringDisclaimer from "../Authoring/AuthoringDisclaimer";
import AuthoringEnablePanel from "../Authoring/AuthoringEnablePanel";
import ApiServices from "../../utils/apiServices";

let _locationOrigin = LocationOrigin;
//_locationOrigin = 'https://predev-ims.jnj.com';
let _timeoutTime = (1000 * (300));

const indexData = (item, url, appliedFilters, searchKeyword, pageNumber, pageSize, shareoption, csPath, csProduct) => {
    let newUrl = window.origin + url;
    const ts = new trackingService();
    if ((window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList')) {
        let { orderedBy, orderedFor } = item;
        if (!orderedBy) orderedBy = '';
        if (!orderedFor) orderedFor = '';
        if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL') {
            ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), `${shareoption} Document`, '', window.location.href, searchKeyword, appliedFilters, item.docTitle, item.r_version_label, item.jj_number, item.searchID, newUrl, item.tempJNJDrugs, item.docType, `${shareoption} Document`, csPath, csProduct, item.domain, pageNumber, pageSize, item.createdDate, orderedBy, orderedFor);
        }
        else if (item.domain === 'SKM') {
            ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), `${shareoption} Document`, '', window.location.href, searchKeyword, appliedFilters, item.docTitle, '', item.domain, item.searchID, newUrl, item.tempJNJDrugs, item.docType, `${shareoption} Document`, csPath, csProduct, item.domain, pageNumber, pageSize, item.createdDate, orderedBy, orderedFor);
        }
        else if (item.domain === 'CTGov') {
            ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), `${shareoption} Document`, '', window.location.href, searchKeyword, appliedFilters, item.docTitle, '', item.docID, item.searchID, newUrl, item.tempJNJDrugs, item.docType, `${shareoption} Document`, csPath, csProduct, item.domain, pageNumber, pageSize, item.createdDate, orderedBy, orderedFor);
        }
        else {
            ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), `${shareoption} Document`, '', window.location.href, searchKeyword, appliedFilters, item.docTitle, item.majorVersionNumber, item.documentNumber, item.searchID, newUrl, item.tempJNJDrugs, item.docType, `${shareoption} Document`, csPath, csProduct, item.domain, pageNumber, pageSize, item.createdDate, orderedBy, orderedFor);
        }
    }
    else {
        ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), `${shareoption} Document`, '', window.location.href, searchKeyword, appliedFilters, item.title, item.majorVersionNumber, item.documentNumber, item.searchID, newUrl, item.tempJNJDrugs, item.docType, `${shareoption} Document`, csPath, csProduct, 'PubMed', pageNumber, pageSize, item.createdDate);
    }
}
const handleSupportingDocs = (url) => {

    const queryParams = new URLSearchParams(document.location.search);
    const params = queryParams.get("query");
    const filters = queryParams.get("filters");
    const q = queryParams.get("q");
    const majorTopicsSynonyms = queryParams.get("majorTopicsSynonyms");
    const authors = queryParams.get("authors");
    const docTitle = queryParams.get("docTitle");
    let str = "";
    let fieldedSearch = queryParams.get("FS");
    let limistArr = [];
    let searchDes = "";
    if (window.location.pathname !== "/ReferencesUsed") {
        if (
            params !== "" &&
            filters !== "" &&
            q !== "All Fields" &&
            !fieldedSearch
        ) {
            searchDes = `${q}: ${params}: ${filters}`;
        } else if (
            params === "" &&
            filters !== "" &&
            q === "All Fields" &&
            !fieldedSearch
        ) {
            searchDes = `${filters}`;
        } else if (
            params !== "" &&
            filters !== "" &&
            q === "All Fields" &&
            !fieldedSearch
        ) {
            searchDes = `${params}: ${filters}`;
        } else if (
            params !== "" &&
            filters === "" &&
            q === "All Fields" &&
            !fieldedSearch
        ) {
            searchDes = `${params}`;
        } else if (
            params !== "" &&
            filters === "" &&
            q !== "All Fields" &&
            !fieldedSearch
        ) {
            searchDes = `${q}: ${params}`;
        } else if (fieldedSearch) {
            // Publication Year
            let toRange = queryParams.get("toYear");
            let fromRange = queryParams.get("fromYear");
            let PublicationYear = "";
            if (toRange) {
                toRange = parseInt(toRange);
            }
            if (fromRange) {
                fromRange = parseInt(fromRange);
            }
            let strYear = limistArr.find((x) => x.key === "strYear");
            if (strYear) {
                let strYearValue = parseInt(strYear.value);
                if (
                    toRange &&
                    fromRange &&
                    fromRange <= strYearValue &&
                    toRange >= strYearValue
                ) {
                    PublicationYear = `${fromRange} To ${toRange}`;
                } else if (
                    toRange &&
                    fromRange &&
                    (fromRange > strYearValue || toRange < strYearValue)
                ) {
                    PublicationYear = `${fromRange} To ${toRange} AND ${strYearValue}`;
                } else if (toRange && strYearValue) {
                    PublicationYear = `${toRange} and earlier AND ${strYearValue}`;
                } else if (fromRange && strYearValue) {
                    PublicationYear = `${fromRange} and later AND ${strYearValue}`;
                } else if (strYearValue) {
                    PublicationYear = `${strYearValue}`;
                }
            } else if (toRange && fromRange) {
                PublicationYear = `${fromRange} To ${toRange}`;
            } else if (toRange) {
                PublicationYear = `${toRange} and earlier`;
            } else if (fromRange) {
                PublicationYear = `${fromRange} and later`;
            }
            limistArr = limistArr.filter((x) => x.key !== "strYear");
            let fcount = queryParams.get("fcount");
            for (let i = 0; i < fcount; i++) {
                let key = queryParams.get(`f${i + 1}`);
                let value = queryParams.get(`fval${i + 1}`);
                limistArr[i] = { key: key, value: value };
            }
            str = params ? `(${params}${filters ? `: ${filters})` : ")"}` : "";
            str = str + (docTitle ? ` (Title: ${docTitle})` : "");
            str = str + (authors ? ` (Authors: ${authors})` : "");
            str =
                str +
                (majorTopicsSynonyms
                    ? ` (Major Topics: ${majorTopicsSynonyms})`
                    : "");
            str =
                str +
                (PublicationYear ? ` (Publication Year: ${PublicationYear})` : "");
            if (fcount > 0 && limistArr.length > 0) {
                limistArr.map((item, index) => {
                    str =
                        str +
                        (item.key
                            ? ` (${this.conversionOfFieldType(item.key)}: ${item.value})`
                            : "");
                });
            }
            searchDes = str;
        }

    }
    let width = 0.80 * window.innerWidth
    let height = 0.85 * window.innerHeight
    let left = 0.10 * window.innerWidth
    let top = 0.10 * window.innerHeight
    let newWindow = window.open(url, '', `width=${width},height=${height},top=${top},left=${left},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`)
    newWindow.supportingDocsSearchStrategyDescription = searchDes;
    newWindow.isSupportingDocs = true;
    //OpenWindow(url)
}
const handleMIAsDocs = (refurl) => {
    let url = `/ReferencesUsed?query=${refurl}`;
    window.open(url, '', `width=${window.innerWidth},height=${window.innerHeight},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`)
}
export default function (props) {
    const {
        item,
        appliedFilters,
        searchKeyword,
        pageNumber,
        pageSize,
        customWidth,
        collapsed,
        csPath,
        csproduct,
        handleUnpin,
        synonymsForDocumentPreview
    } = props
    const [isOpen, setOpenState] = useState(false)
    const [qacollapsed, setqaCollapsed] = useState(false)
    const [showActions, setShowActions] = useState(false)
    const [showReadingList, setShowRL] = useState(false)
    const [showPreview, setPreview] = useState(false)
    const [showAuthoring, setAuthoring] = useState(false)
    const [attachedFiles, setAttachedFiles] = useState([])
    const [sessionID, setSessionID] = useState();
    const [threadID, setThreadID] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [selectedTab, setSelectedTab] = useState('0');
    const [showDisclaimerPopup, setShowDisclaimerPopup] = useState();
    const [showAuthoringEnablePanel, setShowAuthoringEnablePanel] = useState(false)
    /*useEffect(()=>{
       setSessionID(guid)
    },[])*/

    let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'))
    let _function = JSON.parse(localStorage.getItem('function'));
    let url, supportingDocUrl, docIds, referencesUrl
    if (item.supportingDocIDs) {
        docIds = GenerateArrayStrings(item.supportingDocIDs)
        supportingDocUrl = `?query=&q=All%20Fields&filters=&f1=docID&fval1=${docIds}&fcount=1`
    }
    if (item.domain === "MIAs") {
        if (item.spoWebURL) {
            referencesUrl = item.spoWebURL.split('/')
            referencesUrl.pop();
            referencesUrl.push('references used')
            referencesUrl = referencesUrl.join('/')
        }
    }
    if ((window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList')) {
        let { orderedBy, orderedFor } = item;
        if (!orderedBy) orderedBy = '';
        if (!orderedFor) orderedFor = '';
        if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            // url = `/DocURL?ID=${item.docTitle}&cs=${item.domain}`
        }
        else if (item.domain === 'SKM' || item.domain === "MIAs") {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
        }
        else {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
                url = url + `&docState=anr`
            }
        }
        if (item.enclosureDocID) {
            url += `&enclosureID=${item.enclosureDocID}`
        }
    }
    else {
        url = `/DocURLPubMed?sid=PMS&pmid=${item.PMID}`
    }
    useEffect(() => {
        if (collapsed) {
            setqaCollapsed(true)
        }
        else {
            setqaCollapsed(false)
        }
    }, [collapsed])
    function handleShowActions() {
        setShowActions(false)
    }
    function handleCollapsedQuickAction() {
        setqaCollapsed(!qacollapsed)
    }
    function handleClosePinToReadingList(status) {
        setShowRL(status)
    }
    function onDownloadClick() {
        indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Download', csPath !== null ? csPath : '', csproduct !== null ? csproduct : '')
    }
    function onPubMedDownloadClick() {
        indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Download PubMed', csPath !== null ? csPath : '', csproduct !== null ? csproduct : '')
    }
    function onShareClick() {
        setOpenState(!isOpen);
        if ((window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList')) {
            indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Share', '', '')
        }
        else {
            indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Share PubMed', '', '')
        }
    }
    function handlePreviewClose(status) {
        setPreview(false);
        setAuthoring(false);
        setSelectedTab('0')
    }
    const multipleFilesUpload = useCallback(async (attached_Files) => {
        //let { attachedFiles, sessionID, updateAnyFile, newAttachedFiles, removedAttachedFileIndex, newThreadID } = this.state;
        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        }
        let session_id = uuidv4()
        setSessionID(session_id)
        const formData = new FormData();
        attached_Files.map((item, index) => {
            formData.append(`file${index + 1}`, item);
            formData.append(`fileGuid${index + 1}`, item.guid);
            formData.append(`newFileName${index + 1}`, item.newFileName);
        })
        formData.append(`fileCount`, attached_Files.length);
        formData.append(`sessionID`, session_id);
        formData.append(`threadID`, threadID);
        formData.append(`username`, localStorage.getItem('username').toLowerCase().replace(/"/g, ''));
        formData.append(`updateAnyFile`, false);

        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }

        let config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: formData,
            timeout: _timeoutTime
        }
        await axios(config).then((resp) => {
            let response = resp.data;
            if (response.FileUpload) {
                setSelectedTab('1')
            }
        }).catch((error) => {
            console.log(error)
        }).finally(() => {
            //this.setState({ isProcessing: false });
            setIsProcessing(false)
        });
    }, [threadID])
    const fetchDocument = useCallback(async () => {
        let attachedFile = []
        let url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}PreviewService/GenAIAllPagesPreview?strID=${item.searchID}`
        //https://predev-ims.jnj.com/api/PreviewService/GenAIAllPagesPreview?strID=706d063693d4a5c9bd9c065f71ec95a8
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(
            url,
            {
                responseType: "blob",
                headers: _headers
            }
        ).then((response) => {
            let newFileName = item.fileName.split('.').slice(0, -1).join('.');
            const fileName = `${newFileName}.pdf`;
            const data = new Blob([response.data], { type: 'application/pdf' });
            var newFile = new File([data], item.fileName, { type: 'application/pdf' });
            newFile.guid = uuidv4();
            newFile.newFileName = fileName
            attachedFile.push(newFile)
            //this.setState({ base64: data, isProcessing: false })
            setAttachedFiles([newFile])
        }).catch((error) => {
            console.log(error);
            // this.setState({ base64: "", isProcessing: false })
            setAttachedFiles([])
        }).finally(async () => {
            // this.setState({ isProcessing: false })
            multipleFilesUpload(attachedFile)
        })
    }, [item.fileName, item.searchID, multipleFilesUpload])
    const handleAuthoringClick = useCallback(async () => {
        setIsProcessing(true)
        await fetchDocument();
        //await multipleFilesUpload();
    }, [fetchDocument])
    useEffect(() => {
        if (showAuthoring === true) {
            handleAuthoringClick();
        }
    }, [showAuthoring, handleAuthoringClick])
    function handleAuthoringClose() {
        setAttachedFiles([]);
        setSessionID(null);
        setThreadID(null);
        handlePreviewClose();
    }
    function handleOnTabClick(evt) {
        let _showDisclaimerPopup = true;
        let strShowDisclaimerPopup = localStorage.getItem('showPreviewAuthoringDisclaimer');
        if (strShowDisclaimerPopup) {
            _showDisclaimerPopup = !JSON.parse(strShowDisclaimerPopup);
        }
        var tabId = evt.target.id
        if (tabId.split('-')[0] === '1' || tabId.split('-')[0] === '0') {
            /*this.setState({
                selectedTab: tabId.split('-')[0],
                showDisclaimerPopup: _showDisclaimerPopup
            })*/
            setSelectedTab(tabId.split('-')[0])
            setShowDisclaimerPopup(_showDisclaimerPopup)
            if (tabId.split('-')[0] === '1') {
                setIsProcessing(true)
                setAuthoring(true)
                setPreview(false)
            } else if (tabId.split('-')[0] === '0') {
                setPreview(true)
                setAuthoring(false)
            }
        }
    }
    async function handleDisclaimerClose() {
        let strShowDisclaimerPopup = localStorage.getItem('showPreviewAuthoringDisclaimer');
        if (strShowDisclaimerPopup && !JSON.parse(strShowDisclaimerPopup)) {
            let service = new ApiServices();
            let wwid = JSON.parse(localStorage.getItem("wwid"));
            await service.UpdateDisclaimerStatus(wwid, 'isshowpreviewauthoringdisclaimer', true);
        }
        //this.setState({ showDisclaimerPopup: false });
        setShowDisclaimerPopup(false)
        localStorage.setItem('showPreviewAuthoringDisclaimer', JSON.stringify(true));
    }
    function handleShowAuthoringEnablePanelClick() {
        setShowAuthoringEnablePanel(false)

    }
    function renderAuthoringEnablePanel(item) {
        if (item.docType
            && item.docType.includes('Publications')
            && item.genAIEnabled) {
            return (<>
                <div className="quick-action-divider-mobile"></div>

                <div className="action-items-mobile-items-wrapper"
                    title="AI Enabled" onClick={async (evt) => { setShowAuthoringEnablePanel(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'AI Enabled', '', '') }}>
                    <svg width="16" height="16" style={{ width: "30px" }} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM1 9V6C1 3.238 3.238 1 6 1C8.762 1 11 3.238 11 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#008000" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    <span className="action-item-text-mobile">AI Enabled</span>
                </div>
                {/* <button
                    style={{ margin: "5px" }}
                    type="button"
                    className={`gen-ai-action-ai-enable__button`}
                    title="AI Enabled" onClick={async (evt) => { setShowAuthoringEnablePanel(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'AI Enabled', '', '') }}>
                    <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM1 9V6C1 3.238 3.238 1 6 1C8.762 1 11 3.238 11 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#008000" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    <span className="gen-ai-action-review__label">AI Enabled</span>
                </button> */}
            </>)
        }
        else if (item.docType
            && !item.docType.includes('Publications')) {
            return (<>
                <div className="quick-action-divider-mobile"></div>

                <div className="action-items-mobile-items-wrapper"
                    title="AI Enabled" onClick={async (evt) => { setShowAuthoringEnablePanel(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'AI Enabled', '', '') }}>
                    <svg width="16" height="16" style={{ width: "30px" }} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM1 9V6C1 3.238 3.238 1 6 1C8.762 1 11 3.238 11 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#008000" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    <span className="action-item-text-mobile">AI Enabled</span>
                </div>
            </>)
        }
        else if (item.docType
            && item.docType.includes('Publications')
            && !item.genAIEnabled) {
            return (<>
                <div className="quick-action-divider-mobile"></div>
                <div className="action-items-mobile-items-wrapper"
                    title="AI Restricted">
                    <svg width="16" height="16" style={{ width: "30px" }} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.64"></g>
                        <g id="SVGRepo_iconCarrier">
                            <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM18 13H11V6C11 3.238 13.238 1 16 1C18.762 1 21 3.238 21 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#eb1600" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    <span className="action-item-text-mobile">AI Restricted</span>
                </div>

            </>)
        } else {
            return null;
        }
    }
    if (customWidth <= 1000) {
        return (
            <div className="action-items-mobile-wrapper" >
                <img src={quickActionIcon} alt="" width="35" height="35" onClick={e => setShowActions(!showActions)} />
                {showActions &&
                    <div className="action-items-mobile-inner-wrapper" onMouseLeave={handleShowActions}>
                        {(window.location.pathname === '/viewReadingList' || window.location.pathname === '/old_viewReadingList' || window.location.pathname === "/GenAIViewReadingList" || window.location.pathname === '/viewPubMedReadingList') ?
                            window.location.pathname !== '/pubMedResults' &&
                            <div className="action-items-mobile-items-wrapper" onClick={e => { handleUnpin(item); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Unpin', '', ''); }}><img src={quickActionPinMobileIcon} alt="" width="30" height="30" /><span className="action-item-text-mobile">Unpin</span></div>
                            : window.location.pathname !== '/pubMedResults' &&
                            <div className="action-items-mobile-items-wrapper" onClick={e => { setShowRL(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Pin', '', '') }}><img src={quickActionPinMobileIcon} alt="" width="30" height="30" /><span className="action-item-text-mobile">Pin</span></div>
                        }
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && <div className="quick-action-divider-mobile"></div>}
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && item.supportingDocIDs !== undefined && item.supportingDocIDs.length > 0 &&
                            <>
                                <div className="action-items-mobile-items-wrapper" onClick={evt => handleSupportingDocs(supportingDocUrl)}><img src={supportingDocumentMobTabIcon} alt="" width="30" height="30" /><span className="action-item-text-mobile">Supporting Documents</span></div>
                                <div className="quick-action-divider-mobile"></div>
                            </>
                        }
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && item.domain === "MIAs" &&
                            <>
                                <div className="action-items-mobile-items-wrapper" onClick={evt => handleMIAsDocs(referencesUrl)}><img src={supportingDocumentMobTabIcon} alt="" width="30" height="30" /><span className="action-item-text-mobile">References Used</span></div>
                                <div className="quick-action-divider-mobile"></div>
                            </>
                        }

                        <div className="action-items-mobile-items-wrapper" onClick={onShareClick} ><img src={quickActionShareMobileIcon} alt="" width="30" height="30" /><span className="action-item-text-mobile">Share</span></div>
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') &&
                            <>
                                {renderAuthoringEnablePanel(item)}
                            </>
                        }
                    </div>
                }
                {isOpen &&
                    <div>
                        <SharePopup isOpen={isOpen} item={item} appliedFilters={appliedFilters} searchKeyword={searchKeyword} pageNumber={pageNumber} pageSize={pageSize} handleClose={(close) => { setOpenState(close) }} csPath={csPath} csproduct={csproduct} customWidth={customWidth}></SharePopup>
                    </div>
                }
                {showReadingList &&
                    <PinToReadingListPopUp showModal={showReadingList} handleClose={handleClosePinToReadingList} width={customWidth} docID={item.searchID} />
                }
                <Modal
                    show={showAuthoringEnablePanel}
                    size="xl"
                    centered
                    aria-labelledby="contained-modal-title-vcenter"
                    dialogClassName="gen-ai-enable-authoring-popup-transition"
                    className="gen-ai-enable-authoring-z-index-preview"
                    backdropClassName="gen-ai-enable-authoring-z-index-preview-backdrop"
                    scrollable={false}
                >
                    <Modal.Body>
                        <AuthoringEnablePanel
                            customWidth={customWidth}
                            customHeight={window.innerHeight}
                            item={item}
                            handleShowAuthoringEnablePanelClick={handleShowAuthoringEnablePanelClick}>
                        </AuthoringEnablePanel>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
    else {
        return (
            <div className="action-items-wrapper">
                <div className="action-items-inner-wrapper-header" onClick={handleCollapsedQuickAction}>
                    <div className="action-items-main-text">
                        Quick Actions &nbsp;
                        <img src={quickActionDropDown} alt="dropdownIcon" style={{ transform: !qacollapsed ? "matrix(-1, 0, 0, -1, 0, 0)" : null, margin: "0px 0px 1.5%" }} />
                    </div>
                </div>
                <div className="quick-action-divider"></div>
                {!qacollapsed &&
                    <>
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && <>
                            <div className="action-items-inner-wrapper">
                                <a href="javascript:void(0)" className="quick-action-item" onClick={evt => { setPreview(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Preview', '', '') }}>
                                    <img src={previewIcon} alt="" title="Preview" width={20} height={20} />
                                    <div className="action-items-title">
                                        Preview
                                    </div>
                                </a>
                            </div>
                            <div className="quick-action-divider"></div>
                        </>}
                        {item.domain !== "MLR" && (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && (userAccessGroup.includes(Authoring) || _function === "Medical") && <>
                            <div className="action-items-inner-wrapper">
                                <a href="javascript:void(0)" className="quick-action-item" onClick={async (evt) => { setSelectedTab('1'); setAuthoring(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Authoring', '', '') }}>
                                    <img src={iconAuthoringBlue} alt="" title="Authoring" width={20} height={20} />
                                    <div className="action-items-title">
                                        Authoring
                                    </div>
                                </a>
                            </div>
                            <div className="quick-action-divider"></div>
                        </>}
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && item.supportingDocIDs !== undefined && item.supportingDocIDs.length > 0 &&
                            <>
                                <div className="action-items-inner-wrapper">
                                    <a href="javascript:void(0)" onClick={evt => handleSupportingDocs(supportingDocUrl)} className="quick-action-item">
                                        <img src={supportingDocumentWebIcon} alt="" title="Supporting Documents" />
                                        <div className="action-items-supportingDocument-title">
                                            Supporting Documents
                                        </div>
                                    </a>
                                </div>
                                <div className="quick-action-divider"></div>
                            </>
                        }
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && item.domain === "MIAs" &&
                            <>
                                <div className="action-items-inner-wrapper">
                                    <a href="javascript:void(0)" onClick={evt => handleMIAsDocs(referencesUrl)} className="quick-action-item">
                                        <img src={supportingDocumentWebIcon} alt="" title="References Used" />
                                        <div className="action-items-supportingDocument-title">
                                            References Used
                                        </div>
                                    </a>
                                </div>
                                <div className="quick-action-divider"></div>
                            </>
                        }
                        <div className="action-items-inner-wrapper">
                            <a href="javascript:void(0)" onClick={onShareClick} className="quick-action-item">
                                <img src={shareIcon} alt="" title="Share" />
                                <div className="action-items-title">
                                    Share
                                </div>
                            </a>
                        </div>
                        <div className="quick-action-divider"></div>
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') ? <>
                            <div className="action-items-inner-wrapper">
                                <Link target="_blank" to={url} onClick={onDownloadClick} className="quick-action-item">
                                    <img src={downloadIcon} alt="" title="Download" />
                                    <div className="action-items-title">
                                        Download
                                    </div>
                                </Link>
                            </div>
                        </> : <>
                            <div className="action-items-inner-wrapper">
                                <Link target="_blank" to={url} onClick={onPubMedDownloadClick} className="quick-action-item">
                                    <img src={downloadIcon} alt="" title="Download" />
                                    <div className="action-items-title">
                                        Download
                                    </div>
                                </Link>
                            </div></>}
                        {(window.location.pathname !== '/pubMedResults') && <div className="quick-action-divider"></div>}
                        {(window.location.pathname === '/viewReadingList' || window.location.pathname === '/old_viewReadingList' || window.location.pathname === "/GenAIViewReadingList" || window.location.pathname === '/viewPubMedReadingList') ?
                            window.location.pathname !== '/pubMedResults' &&
                            <div className="action-items-inner-wrapper">
                                <a href="javascript:void(0)" className="quick-action-item" onClick={e => { handleUnpin(item); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Unpin', '', ''); }}>
                                    <img src={pushPinIcon} alt="" title="Unpin from Reading List" />
                                    <div className="action-items-title">
                                        Unpin
                                    </div>
                                </a>
                            </div>
                            : window.location.pathname !== '/pubMedResults' &&
                            <div className="action-items-inner-wrapper">
                                <a href="javascript:void(0)" className="quick-action-item" onClick={e => { setShowRL(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Pin', '', '') }}>
                                    <img src={pushPinIcon} alt="" title="Pin to Reading List" />
                                    <div className="action-items-title">
                                        Pin
                                    </div>
                                </a>
                            </div>
                        }
                        {isOpen &&
                            <div>
                                <SharePopup isOpen={isOpen} item={item} appliedFilters={appliedFilters} searchKeyword={searchKeyword} pageNumber={pageNumber} pageSize={pageSize} handleClose={(close) => { setOpenState(close) }} csPath={csPath} csproduct={csproduct} customWidth={customWidth}></SharePopup>
                            </div>
                        }
                        {showReadingList &&
                            <PinToReadingListPopUp showModal={showReadingList} handleClose={handleClosePinToReadingList} width={customWidth} docID={item.searchID} />
                        }
                        {((showPreview || showAuthoring) && (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList')) && <>{
                            (item.domain !== "MLR" && (userAccessGroup.includes(Authoring) || _function === "Medical")) ?
                                renderModelPopup() :
                                <DocumentPreview customWidth={customWidth} sourceItem={item} fileName={item.fileName} docTitle={item.docTitle} searchID={item.searchID} searchKeyword={searchKeyword} synonyms={synonymsForDocumentPreview} /*searchID='1a08dc3a4077c024d071f88b33f97c22' */ showPreview={showPreview} handleClose={handlePreviewClose} />}</>
                            // <AiNotebookDocumentPreview customWidth={customWidth} sourceItem={item} fileName={item.fileName} docTitle={item.docTitle} searchID={item.searchID} searchKeyword={searchKeyword} synonyms={synonymsForDocumentPreview} /*searchID='1a08dc3a4077c024d071f88b33f97c22' */ showPreview={showPreview} handleClose={handlePreviewClose} />
                        }
                        {/* {(showPreview && window.location.pathname !== '/nlpresults') &&
                            <DocumentPreview customWidth={customWidth} sourceItem={item} fileName={item.fileName} docTitle={item.docTitle} searchID={item.searchID} searchKeyword={searchKeyword} synonyms={synonymsForDocumentPreview}  showPreview={showPreview} handleClose={handlePreviewClose} />
                        } */}
                        {/*{isProcessing &&
                            <Modal
                                show={isProcessing}
                                size="lg md sm xs"
                                centered
                                aria-labelledby="contained-modal-title-vcenter"
                                dialogClassName="savePopUp"
                                className="gen-ai-answering-search-spinner-popup"
                                backdropClassName="z-index-gen-ai-answering-search-spinner-popup"
                                scrollable={true}>
                                <div style={{ padding: "0 5%" }}>
                                    <div style={{ fontSize: "14px", textAlign: "center" }}>
                                        <Modal.Body>
                                            <img src={imsLoader} alt="" width={100} height={100} />
                                            <div className="saveModal-heading" style={{ color: "#0074B0" }}>{`Please wait while loading the document.`} </div>
                                        </Modal.Body>
                                    </div>
                                </div>
                            </Modal>}*/}
                        {showDisclaimerPopup && <AuthoringDisclaimer showPopup={showDisclaimerPopup} handleDisclaimerClose={handleDisclaimerClose} />}
                    </>
                }
            </div>
        )
    }
    function renderModelPopup() {
        return (<Modal
            show={(showPreview || showAuthoring)}
            size="xl"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="authoring-popup-transition"
            className="z-index-preview"
            backdropClassName="z-index-preview-backdrop"
            scrollable={false}
        >
            <Modal.Body>
                <Tabs
                    defaultTab={selectedTab.toString()}
                    selectedindex={selectedTab}
                    onClick={handleOnTabClick}
                >
                    <TabList className="tablist-item-notebook" style={{ width: "49.5%", marginLeft: "50%", marginTop: '2px' }}>
                        <Tab tabFor="0" className={selectedTab === '0' ? "tab-list-item-notebook  tab-list-item-notebook-active" : "tab-list-item-notebook"}>Search</Tab>
                        <Tab tabFor="1" className={selectedTab === '1' ? "tab-list-item-notebook tab-list-item-notebook-active" : "tab-list-item-notebook"}>Authoring</Tab>
                        <span style={{ cursor: "pointer", float: "right" }}>
                            {selectedTab === '1' && <>
                                <a className="authoring-model-body-content-link" onClick={() => setShowDisclaimerPopup(true)} >Gen Ai Adherence Policy</a>
                                &nbsp;&nbsp;&nbsp;&nbsp;</>}
                            <img onClick={e => { handleAuthoringClose() }} src={crossIcon} width={10} height={10} alt="Cross" /></span>
                    </TabList>

                    <TabPanel tabId="0" className='tabpanel-list-item-notebook'>
                        <AiNotebookDocumentPreview customWidth={customWidth} sourceItem={item} fileName={item.fileName} docTitle={item.docTitle} searchID={item.searchID} searchKeyword={searchKeyword} synonyms={synonymsForDocumentPreview} /*searchID='1a08dc3a4077c024d071f88b33f97c22' */ showPreview={(showPreview || showAuthoring)} handleClose={handlePreviewClose} isOpenAuthoringTab={false} />
                    </TabPanel>
                    <TabPanel tabId="1" className='tabpanel-list-item-notebook'>
                        <div className="ai-notebook-doc-authoring-wrapper">
                            {(isProcessing) ? <div style={{ textAlign: "center", padding: "10%" }} className="nlp-doc-preview-loader-wrapper">
                                <b>Loading a document</b>
                                <br />
                                <img src={imsLoader} alt="Loading Filters" width={100} height={100} />
                            </div> :
                                <GenAIAuthoringIndex customWidth={customWidth} customHeight={window.innerHeight} attachedFiles={attachedFiles} sessionID={sessionID} isFromCore={true} handleClose={handleAuthoringClose} />}
                        </div>
                    </TabPanel>
                </Tabs>

            </Modal.Body>
        </Modal>)
    }
}